import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator } from '@app/modal/state-modal/state-modal.component';
import { BusinesscoItem, LogisticService } from '@app/services/logistic.service';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { Grid } from '@app/core/components/grid/grid.model';
import { AccountingProcessingFunctionItem, AccountingProcessingGet, AccountingProcessingService, GetAccountingProcessingParams } from './accounting-processing.service';

@Component({
    selector: 'tt-accounting-processing',
    templateUrl: './accounting-processing.component.html',
    styleUrls: ['./accounting-processing.component.css'],
})
export class AccountingProcessingComponent implements OnInit {
    @Input()
    public params?: GetAccountingProcessingParams;

    public get?: AccountingProcessingGet;

    public companies: BusinesscoItem[] = [];

    public accountingFunctions: AccountingProcessingFunctionItem[] = [];

    public grid?: GridOptions;

    constructor(
        private logistic: LogisticService,
        private accountingProcessing: AccountingProcessingService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {}

    public onBusinessCoChanged() {
        this.readGrid();
    }

    private async loadGet() {
        if (!!this.params) {
            this.get = await this.accountingProcessing.getAccountingProcessing(this.params);
        }
    }

    private readGrid() {
        if (!this.grid) {
            this.grid = new Grid().setRememberId('w_accountingprocessing.custactgrid').setLoadDataFunction({ method: 3469, parameters: () => ({ businessco_no: this.get!.businessco_no }) });
        } else {
            this.grid.gridfunc?.read();
        }
    }

    private async loadAccountingFunctions() {
        this.accountingFunctions = await this.accountingProcessing.getAccountingProcessingFunctions();
    }

    private async loadCompanies() {
        this.companies = await this.logistic.getCompanies();
    }

    private async init() {
        this.loadCompanies();
        this.loadAccountingFunctions();
        await this.loadGet();
        this.readGrid();
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.params = this.navigator.params as any;

            // TODO: remove after testing
            this.params = { custact_no: '0' };

            this.init();
        }
    }
}
